import { GlobalState } from '@leverege/ui-redux';
import { Context } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import { AllowedReducer, Constants } from '@leverege/api-redux';
import { Dialogs } from '@leverege/ui-elements';
import EnableDialog from "../../dashboard/viewer/theftRecovery/views/EnableDialog.js";
import DisableDialog from "../../dashboard/viewer/theftRecovery/views/DisableDialog.js";
import Util from "../../../views/salesFlow/Util.js";
const ACTIVATE_ACTION = 'activateTheftRecovery';
const DEACTIVATE_ACTION = 'deactivateTheftRecovery';
export default {
  id: 'recovrGeneric.action.TheftRecovery',
  name: 'Theft Recovery',
  layout: {
    sort: 'security.theftRecovery',
    sectionName: 'Security'
  },
  matches: [{
    client: ['GroupScreen', 'ItemInfoScreen'],
    use: ['contextMenu', 'mobileActionBar'],
    objectType: 'assetLocators'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: 'contextMenu'
  }],
  prepare: async context => {
    const targets = Context.getTargetsOfType(context, 'assetLocators');

    // get resource id
    const target = targets?.[0];
    const assetId = target?.id;
    const asset = GlobalState.get().models?.lookup[assetId];
    const systemId = asset?.systemId;
    const companyId = asset?.data?.company?.id;
    const locationId = asset?.data?.location?.id;
    const orgId = asset?.data?.organization?.id;
    const ACTION = asset?.data?.case ? DEACTIVATE_ACTION : ACTIVATE_ACTION;
    const endpoint = asset?.data?.case ? 'deactivate' : 'activate';
    return GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      let res;
      if (orgId) {
        res = await api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).grp('assetsLocators').obj(assetId).srv('theftRecovery').patch(endpoint, null, {
          test: true
        });
      } else {
        res = await api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp('assetsLocators').obj(assetId).srv('theftRecovery').patch(endpoint, null, {
          test: true
        });
      }
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId: assetId,
        action: ACTION,
        allowed: res.allowed === true
      });
      return res.allowed === true;
    });
  },
  isPrepared: context => {
    const targets = Context.getTargetsOfType(context, 'assetLocators');
    if (targets?.length !== 1) {
      return true;
    }

    // get resource id
    const target = targets?.[0];
    const assetId = target?.id;
    const asset = GlobalState.get().models?.lookup[assetId];
    const ACTION = asset?.data?.case ? DEACTIVATE_ACTION : ACTIVATE_ACTION;
    const a = AllowedReducer.get(GlobalState.get(), assetId);
    return a[ACTION] != null;
  },
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'assetLocators');
    if (targets?.length !== 1) {
      return false;
    }

    // get resource id
    const target = targets?.[0];
    const assetId = target?.id;
    const asset = GlobalState.get().models?.lookup[assetId];
    const locator = asset?.data?.locator;
    if (!locator || !Util.isLocatorActivated(locator)) {
      return false;
    }

    // get action flag
    const ACTION = asset?.data?.case ? DEACTIVATE_ACTION : ACTIVATE_ACTION;
    const a = AllowedReducer.get(GlobalState.get(), assetId);
    return a[ACTION] === true;
  },
  appearance: props => {
    const context = props?.context?.clientState?.actionsContext || props.context;
    const item = Context.getTarget(context);

    // const stolen = item?.data?.data?.locator?.data?.businessState === 'stolen'
    const inTheftRecoveryMode = item?.data?.data?.case;
    return {
      name: inTheftRecoveryMode ? 'Deactivate Theft Recovery' : 'Activate Theft Recovery',
      icon: 'https://storage.googleapis.com/prd-generic-kudelski-ui-assets/icon-theft-shield.svg',
      imageOpts: {
        style: {
          width: '20px',
          height: '20px'
        }
      }
    };
  },
  perform: props => {
    const context = props?.context?.clientState?.actionsContext || props.context;
    const {
      clientProps,
      target
    } = context;
    const item = Context.getTarget(context);
    let [actions] = DataSources.getActions(target);
    if (!actions) {
      actions = clientProps.actions;
    }

    // const stolen = item?.data?.data?.locator?.data?.businessState === 'stolen'
    const inTheftRecoveryMode = item?.data?.data?.case;
    if (inTheftRecoveryMode) {
      Dialogs.show({
        component: DisableDialog,
        props: {
          caseActions: actions.parent().parent().child('cases').item(item?.data?.case?.id),
          sharedProps: {
            ...clientProps,
            item: item.data,
            actions
          }
        }
      });
    } else {
      Dialogs.show({
        component: EnableDialog,
        props: {
          sharedProps: {
            ...clientProps,
            item: item.data,
            actions
          }
        }
      });
    }
  }
};